import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';
import * as guestActions from '../../actions/guestActions';
import routerHistory from '../../routerHistory';
import { ROUTES } from '../../const';

class GuestSessionExpiredModal extends React.Component {
  constructor(props) {
    super(props);
    this.reenter = this.reenter.bind(this);
    this.requestAccount = this.requestAccount.bind(this);
  }

  static propTypes = {
    active: PropTypes.bool,
    guestActions: PropTypes.object
  };

  reenter() {
    const { guestActions } = this.props;
    guestActions.setSessionExpiredModal(false);
    guestActions.reenterGuestSession();
  }

  requestAccount() {
    const { guestActions } = this.props;
    guestActions.exitGuestSession();
    routerHistory.push(ROUTES.JOIN);
  }

  render() {
    const { active } = this.props;

    return (
      <Modal
        id="guestSessionExpired"
        title={I18n.t('guest.sessionExpired.title')}
        active={active}
        children={<Paragraph className="text-grey-700">{I18n.t('guest.sessionExpired.body')}</Paragraph>}
        footer={
          <>
            <Button onClick={this.requestAccount} label={I18n.t('guest.sessionExpired.requestAccount')}></Button>
            <Button onClick={this.reenter} primary label={I18n.t('guest.sessionExpired.reenter')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    active: state.guest.sessionExpiredModalIsOpen
  };
}

function mapDispatchToProps(dispatch) {
  return {
    guestActions: bindActionCreators(guestActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestSessionExpiredModal);
